import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";

// components
import { CRow } from "@coreui/react-pro";
import AppTextColumnDetails from "../general-details/AppTextColumnDetails";

// helpers
import formatCurrency from "src/helpers/format-currency";

const BookingDetails = ({ bookingDetails, serviceDetails }) => {
  const currency = useSelector((state) => state.currency);

  const transactionDetails =
    bookingDetails &&
    bookingDetails.transaction_details &&
    bookingDetails.transaction_details[0];
  const transactionMetadata =
    transactionDetails &&
    transactionDetails.metadata &&
    JSON.parse(transactionDetails.metadata);

  return (
    <>
      <CRow>
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title={
            serviceDetails &&
            serviceDetails?.service &&
            serviceDetails?.service?.title
          }
          subtitle={serviceDetails && serviceDetails?.title}
        />
        <AppTextColumnDetails
          colSize="2"
          className="mb-3"
          title={`${
            bookingDetails &&
            bookingDetails?.guests &&
            bookingDetails?.guests?.length
          } Guests`}
        />
        <AppTextColumnDetails
          colSize="2"
          className="mb-3"
          title={`${currency && currency.code} ${formatCurrency(
            transactionMetadata?.service_price
          )}`}
        />
      </CRow>
      <CRow>
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title={"Service Tax"}
        />
        <AppTextColumnDetails colSize="2" className="mb-3" title={``} />
        <AppTextColumnDetails
          colSize="2"
          className="mb-3"
          title={`${currency && currency.code} ${formatCurrency(
            transactionMetadata?.service_tax
          )}`}
        />
      </CRow>
      <CRow>
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title={"Transaction Fee"}
        />
        <AppTextColumnDetails colSize="2" className="mb-3" title={``} />
        <AppTextColumnDetails
          colSize="2"
          className="mb-3"
          title={`${currency && currency.code} ${formatCurrency(
            transactionMetadata?.transaction_fee
          )}`}
        />
      </CRow>
      <CRow>
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title={"Transaction Tax"}
        />
        <AppTextColumnDetails colSize="2" className="mb-3" title={``} />
        <AppTextColumnDetails
          colSize="2"
          className="mb-3"
          title={`${currency && currency.code} ${formatCurrency(
            transactionMetadata?.transaction_tax
          )}`}
        />
      </CRow>
      <CRow>
        <AppTextColumnDetails
          colSize="5"
          className="mb-3"
          title="Confirmed Date/Time"
          subtitle={moment(bookingDetails?.booking_time?.date).format(
            "dddd, DD/MM/YYYY HH:mm"
          )}
        />
        <AppTextColumnDetails
          colSize="4"
          className="mb-3"
          title="Total Amount"
          subtitle={`${currency && currency.code} ${formatCurrency(
            transactionMetadata?.total_amount
          )}`}
        />
      </CRow>
    </>
  );
};

export default BookingDetails;
